module.exports = __webpack_public_path__ + "img/logo_x4.b609a2e9.jpg";